"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardType = undefined;

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

var _globalize = require("globalize");

var _globalize2 = _interopRequireDefault(_globalize);

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Validation", "App");

var $ = require("jquery");
var discountService = abp.services.api.discount;

module.exports = exports.default = function () {
    $("#checkPriceSubmit").off("click").on("click", function () {
        var date = moment($("input#Date").val(), "DD.MM.YYYY HH:mm").format("L");

        var loyaltyProgramId = $("select#LoyaltyProgramId option[selected='selected']").val();
        loyaltyProgramId = loyaltyProgramId ? parseInt(loyaltyProgramId) : -1;

        var selecterdProductContainer = $("span#select2-ProductId-container").attr("title");

        var productId = undefined;
        $("select#ProductId option").each(function () {
            if ($(this).text() === selecterdProductContainer) {
                productId = parseInt($(this).val());
            }
        });

        var isIsicCard = $("input#IsIsicCard").attr("checked");
        var isSphereCard = $("input#IsSphereCard").attr("checked");
        var isSphereCardVip = $("input#IsSphereCardVip").attr("checked");

        var customerCards = [];

        if (isIsicCard) {
            customerCards.push(CardType.Isic);
        }
        if (isSphereCard) {
            customerCards.push(CardType.Sphere);
        }
        if (isSphereCardVip) {
            customerCards.push(CardType.SphereVIP);
        }

        var customerType = $("#CustomerType").val() || 0;

        if (!productId) {
            _notify2.default.error(resx.Validation.RequiredAttribute_ValidationError.replace("{0}", $("label[for='ProductId']").text()));
        } else {

            $("#appliedDiscounts").DataTable().query(function (x) {
                x.date = date, x.loyaltyProgramId = loyaltyProgramId, x.coupon = null, x.customerCard = customerCards.length > 0 ? customerCards : "", x.amount = 1, x.id = productId, x.customerType = customerType;
            });
            $("#appliedDiscounts").DataTable().ajax.reload(null, false);

            discountService.getCartPriceForOneProduct(date, productId, 1, loyaltyProgramId, customerCards, 0, null, customerType).done(function (result) {
                $("div#ProductPrices").html("\n                            <div class=\"row\">\n                                <div class=\"col-sm-6 col-xs-6 col-md-6 col-lg-6\">" + resx.App.Price + "</div>\n                                <div class=\"col-sm-6 col-xs-6 col-md-6 col-lg-6 text-right\">" + _globalize2.default.format(result.totalPrice.standardPrice, "C0") + "\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-sm-6 col-xs-6 col-md-6 col-lg-6\">" + resx.App.FinalPrice + "</div>\n                                <div class=\"col-sm-6 col-xs-6 col-md-6 col-lg-6 text-right\">" + _globalize2.default.format(result.totalPrice.finalPrice, "C0") + "\n                                </div>\n                            </div>\n                        ");
            }).fail(function (err) {
                _notify2.default.error(L(err.responseJSON.error.message));
            });
        }
    });

    $("input[type='checkbox']", $("#checkProductPrice")).off("click").on("click", function () {
        var checked = $(this).attr("checked");

        if (checked) {
            $(this).removeAttr("checked");
        } else {
            $(this).attr("checked", "checked");
        }
    });
};

var CardType = exports.CardType = {
    Sphere: 1,
    Isic: 2,
    SphereVIP: 3
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/productPriceCheck.js
// module id = 447
// module chunks = 0